import { render, staticRenderFns } from "./myCertificateHonour.vue?vue&type=template&id=87299090&"
import script from "./myCertificateHonour.vue?vue&type=script&lang=js&"
export * from "./myCertificateHonour.vue?vue&type=script&lang=js&"
import style0 from "./myCertificateHonour.vue?vue&type=style&index=0&id=87299090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports